import { selectFeatureFlag } from 'reducers/selectors';
import { createSelector } from 'reselect';
export const selectActiveReferralProgramReward = createSelector([
    (store) => store.referrals.activeProgram,
    (store) => selectFeatureFlag(store, 'new_referrals').value,
], (activeProgram, new_referrals) => {
    if (!activeProgram?.currency) {
        return undefined;
    }
    if (activeProgram.getPremiumCredit && new_referrals) {
        return {
            currency: activeProgram.currency,
            get: activeProgram.getPremiumCredit,
            give: activeProgram.givePremiumTrialDays,
        };
    }
    if (activeProgram.get) {
        return {
            currency: activeProgram.currency,
            get: activeProgram.get,
            give: activeProgram.givePremiumTrialDays,
        };
    }
    return undefined;
}, {
    memoizeOptions: {
        resultEqualityCheck: (a, b) => a?.currency === b?.currency && a?.get === b?.get && a?.give === b?.give,
    },
});
